/**
 * Vertical space reserved for a page in the pdf scroll.
 * Using the largest side keeps the slot identical whatever the page rotation,
 * so rotating a page never shifts the following pages nor the synced detail blocks.
 */
export const getPageSlotHeight = (page) => Math.max(page?.height || 0, page?.width || 0);
